import React, { useEffect, useRef } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Lenis from 'lenis';
import 'lenis/dist/lenis.css';
import './App.css';
import './responsive.css';
import './styles/cookieyes-custom.css';
import Home from './pages/Home';
import OmOsSide from './pages/omos/omside';
import TjenesterPage from './pages/tjenester/tjenester';
import HjemmesiderPage from './pages/hjemmesider/hjemmesider';
import SEOPage from './pages/seo/seoside';
import PriserSide from './pages/priser/priserside';
import KontaktSide from './pages/kontakt/kontaktside';
import CasesSide from './pages/casesside/casesside';
import ArtikelSide from './pages/artikler/artikler';
import ArtikelOversigt from './pages/artikelside/artikelside';
import MinimalistiskWebdesign from './pages/artikelside/articles/minimalistisk-webdesign';
import VerdenMedAI from './pages/artikelside/articles/Verden-med-AI';
import MobilvenligeHjemmesider from './pages/artikelside/articles/mobilvenlige-hjemmesider';
import GoogleIndeksering from './pages/artikelside/articles/google-indeksering';
import SEOogAI2026 from './pages/artikelside/articles/seoogaii2026';
import RedirectHandler from './components/RedirectHandler';
import ScrollToTop from './components/ScrollToTop';
import CookiesPolitik from './pages/politikker/cookies/cookies';
import PrivatlivsPolitik from './pages/politikker/privatlivspolitik/privatlivspolitik';
import Vilkaar from './pages/politikker/vilkaar/vilkaar';

function App() {
  const lenisRef = useRef(null);

  useEffect(() => {
    // Initialiser Lenis
    const lenis = new Lenis({
      duration: 0.4, // lavere = mindre "styrke"/inerti
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      direction: 'vertical',
      gestureDirection: 'vertical',
      smooth: true,
      mouseMultiplier: 0.3, // lavere = mindre følsom mus
      smoothTouch: false,
      touchMultiplier: 0.6, // lavere = mindre følsom touch
      infinite: false,
    });

    lenisRef.current = lenis;

    // Handle anchor links on page load
    const handleAnchorLinks = () => {
      const hash = window.location.hash;
      if (hash) {
        setTimeout(() => {
          const element = document.querySelector(hash);
          if (element) {
            lenis.scrollTo(element, { 
              offset: -100, // Account for fixed header
              duration: 1.5 
            });
          }
        }, 100);
      }
    };

    // Call on initial load
    handleAnchorLinks();

    // Listen for hash changes
    window.addEventListener('hashchange', handleAnchorLinks);

    // Animation loop
    const raf = (time) => {
      lenis.raf(time);
      requestAnimationFrame(raf);
    };

    requestAnimationFrame(raf);

    // Cleanup
    return () => {
      window.removeEventListener('hashchange', handleAnchorLinks);
      lenis.destroy();
    };
  }, []);

  return (
    <HelmetProvider>
      <Router>
        <div className="App">
          <RedirectHandler />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/omos" element={<OmOsSide />} />
            <Route path="/tjenester" element={<TjenesterPage />} />
            <Route path="/hjemmesider" element={<HjemmesiderPage />} />
            <Route path="/seo" element={<SEOPage />} />
            <Route path="/priser" element={<PriserSide />} />
            <Route path="/cases" element={<CasesSide />} />
            <Route path="/kontakt" element={<KontaktSide />} />
            <Route path="/artikler/seo-guide-2025" element={<ArtikelSide />} />
            <Route path="/artikler/verden-med-ai" element={<VerdenMedAI />} />
            <Route path="/artikler/mobilvenlige-hjemmesider" element={<MobilvenligeHjemmesider />} />
            <Route path="/artikler/google-indeksering" element={<GoogleIndeksering />} />
            <Route path="/artikler/seoogaii2026" element={<SEOogAI2026 />} />
            <Route path="/artikler/:slug" element={<ArtikelOversigt />} />
            <Route path="/artikler" element={<ArtikelOversigt />} />
            <Route path="/hvad-koster-hjemmesider" element={<ArtikelOversigt />} />
            <Route path="/cookies" element={<CookiesPolitik />} />
            <Route path="/privatlivspolitik" element={<PrivatlivsPolitik />} />
            <Route path="/vilkaar" element={<Vilkaar />} />
          </Routes>
          <ScrollToTop />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
